(function() {
  function renderizarDrawer() {
    var containers = document.querySelectorAll('[data-essential-cart-element="line-item-properties"]:not([data-kit-processado])');
    
    containers.forEach(function(container) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var kitItem = cart.items.find(function(item) {
            return item.properties && Object.keys(item.properties).some(function(k) {
              return k.startsWith('_img_');
            });
          });
          if (!kitItem || !kitItem.properties) return;

          var props = kitItem.properties;
          var imgMap = {};
          var corMap = {};

          Object.keys(props).forEach(function(chave) {
            if (chave.startsWith('_img_')) {
              imgMap[chave.replace('_img_', '')] = props[chave];
            } else {
              corMap[chave] = props[chave];
            }
          });

          if (!Object.keys(imgMap).length) return;

          var divs = container.querySelectorAll('div');
          divs.forEach(function(div) { div.style.display = 'none'; });

          var bloco = document.createElement('div');
          bloco.style.cssText = 'display: flex; flex-direction: column; gap: 6px; margin-top: 4px;';

          Object.keys(corMap).forEach(function(nome) {
            var img = imgMap[nome] || '';
            var cor = corMap[nome];
            var row = document.createElement('div');
            row.style.cssText = 'display: flex; align-items: center; gap: 8px;';
            row.innerHTML = img
              ? '<img src="' + img + '" width="32" height="32" style="width:32px;height:32px;object-fit:cover;border-radius:4px;flex-shrink:0;" /><span style="font-size:12px;color:#333;">' + nome + ': ' + cor + '</span>'
              : '<span style="font-size:12px;color:#333;">' + nome + ': ' + cor + '</span>';
            bloco.appendChild(row);
          });

          container.appendChild(bloco);
          container.dataset.kitProcessado = 'true';
        });
    });
  }

  var debounceTimer;
  var drawerObserver = new MutationObserver(function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(renderizarDrawer, 150);
  });

  drawerObserver.observe(document.body, { childList: true, subtree: true });
})();